import { type AiHint, TestCase, TestStatus } from "sj-ui-toolkit/src/client";

export type ProcessedSubmission = {
  runId: string;
  submittedAt: Date;
  result: SubmissionResult;
  tests: TestResult[];
  code?: SubmittedCode;
  aiHint?: AiHint;
};

// Represents code that has been submitted for a specific volume in the sandbox
export type SubmittedCode = {
  volumeName: string;
  languageLabel: string;
  text: string;
};

// The result of evaluating a code submission
export type SubmissionResult =
  | {
      type: "incomplete";
      progress: TestStatus["progress"];
    }
  | {
      type: "failed";
      testName: string;
      errorMessage: string;
    }
  | { type: "error" }
  | { type: "unknown" }
  | { type: "passed" }
  | { type: "timeout" };

export enum SubmissionTestStatus {
  PASSED = "passed",
  FAILED = "failed",
  ERROR = "error",
  SKIPPED = "skipped",
  TIMEOUT = "timeout",
}

export type TestResult = TestCase & {
  status: SubmissionTestStatus;
};
